export interface IPslEmailSubscription {
    psl: string;
    subscriptionType: ESubscriptionType[];
}

export enum ESubscriptionType {
    ALL = "all",
    REJECTED = "rejected",
    APPROVED = "approved"
}



// WEBPACK FOOTER //
// ./src/data/IPslEmailSubscription.tsx